export default __webpack_public_path__ + "static/landing-video-ec4fd55b6c0eca4bb3aac18e71840b99.mp4";